module.exports = __webpack_public_path__ + "img/ic24Gender.7037dce4.svg";